import React from 'react';

import Hero from '../components/hero';
import Opener from '../components/speech-bubble-opener';
import Education from '../components/education';
import Laptop from '../components/laptop-cta';

const EducationTemplate = () => {
	return (
		<div>
			<Hero
				img="/img/Education_Masthead.svg"
				mobileImg="/img/education-mobile.svg"
				alt="People shaking hands illustration"
				title="Education & Awareness"
				subtext="Learn more about mental health and its effects on our community."
				className="text"
			/>
			<Opener
				strong=" Start Talking."
				base={['MENTAL HEALTH', 'SUICIDE', 'ADDICTIONS', 'YOUTH SUPPORT']}
				content="It used to be that a person was considered to be in good mental health simply if they showed no signs or symptoms of mental illness. But in recent years there has been a shift to a more holistic view of mental health. Here’s where we"
			/>
			<Education />
			<Laptop img="/img/ComputerMan.svg" />
		</div>
	);
};

export default EducationTemplate;
